import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { RouterProvider } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AuthProvider from './contexts/AuthProvider';
import NavbarProvider from './contexts/NavbarProvider';
import reportWebVitals from './reportWebVitals';
import './styles/global.css';
import { router } from './utils/Router';

// creating tanstack-query client instance here
const queryClient = new QueryClient();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <NavbarProvider>
            <RouterProvider router={router} />
          </NavbarProvider>
        </AuthProvider>
      </QueryClientProvider>
      <ToastContainer position='top-center' />
    </HelmetProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
